
import React, { useState, ReactNode } from 'react';

type DialogContentProps = {
  onClose: () => void;
  [key: string]: any;
};

export function useDialog() {
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState<ReactNode | null>(null);

  // Open the dialog with content
  const open = (dialogContent: ReactNode) => {
    setContent(dialogContent);
    setIsOpen(true);
  };

  // Close the dialog
  const close = () => {
    setIsOpen(false);
    setTimeout(() => {
      setContent(null);
    }, 300); // Small delay to allow for animation
  };

  return {
    isOpen,
    content,
    open,
    close,
  };
}
